enum TaskAddonAssignMethod {
    PAYMENT = 'PAYMENT',
    WITHOUT_PAYMENT = 'WITHOUT_PAYMENT',
}

export default TaskAddonAssignMethod;
